import type { OverviewInsight, OverviewSummary } from '../domain/overview'

type InsightStrings = {
	youHave: string
	requestPendingSingular: string
	requestPendingPlural: string
	requestPendingAfter: string
	teamApprovalBeforeSingular: string
	teamApprovalBeforePlural: string
	teamApprovalLinkSingular: string
	teamApprovalLinkPlural: string
	teamApprovalAfter: string
	allClear: string
}

const buildInsights = (summary: OverviewSummary, s: InsightStrings): OverviewInsight[] => {
	const insights: OverviewInsight[] = []

	if (summary.myPendingRequestsCount > 0) {
		const n = summary.myPendingRequestsCount
		insights.push({
			key: 'pending-requests',
			before: `${s.youHave} `,
			link: `${n} ${n === 1 ? s.requestPendingSingular : s.requestPendingPlural}`,
			after: ` ${s.requestPendingAfter}`,
			href: '/hr/time-off',
		})
	}

	if (summary.teamPendingApprovalsCount > 0) {
		const n = summary.teamPendingApprovalsCount
		insights.push({
			key: 'team-approvals',
			before: `${n === 1 ? s.teamApprovalBeforeSingular : s.teamApprovalBeforePlural} `,
			link: `${n} ${n === 1 ? s.teamApprovalLinkSingular : s.teamApprovalLinkPlural}`,
			after: s.teamApprovalAfter,
			href: '/hr/time-off',
		})
	}

	if (insights.length === 0) {
		insights.push({
			key: 'clear',
			before: '',
			link: '',
			after: s.allClear,
			href: '#',
		})
	}

	return insights
}

export { buildInsights }
export type { InsightStrings }
